<div class="dialog">
  <div class="header">
    Are you sure you want to hide <br> {{data.name}} patient from my Virtual Consult screen?
  </div>
  <div class="body">
    They will no longer be visible here but you will be able to search for them on my Patients screen
  </div>
  <div class="footer">
    <button class="btn-gray" (click)="removePatient(null)">Cancel</button>
    <button class="btn-blue" (click)="removePatient(data.id)" [mat-dialog-close]="true">Confirm</button>
  </div>
</div>